import React from 'react'

export default function NoMobileNumber() {
  return (
    <div>NoMobileNumber</div>
  )
}
